/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type PortfolioFolders_portfoliosConnection$ref: FragmentReference;
export type PortfolioFolders_portfoliosConnection = {|
  +edges: ?$ReadOnlyArray<?{|
    +node: ?{|
      +id: string,
      +serviceId: ?string,
      +name: ?string,
      +items: ?{|
        +totalResults: ?number,
        +numberOfPages: ?number,
        +pageInfo: {|
          +startCursor: ?string,
          +endCursor: ?string,
        |},
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +item: ?{|
              +photos: ?$ReadOnlyArray<?{|
                +versions: ?$ReadOnlyArray<?{|
                  +webPath: ?string
                |}>
              |}>
            |}
          |}
        |}>,
      |},
    |}
  |}>,
  +$refType: PortfolioFolders_portfoliosConnection$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PortfolioFolders_portfoliosConnection",
  "type": "PortfoliosConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "PortfoliosEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "PortfolioV2",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "id",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "serviceId",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "name",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "items",
              "storageKey": "items(first:4,sortBy:\"CUSTOM\")",
              "args": [
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 4,
                  "type": "Int"
                },
                {
                  "kind": "Literal",
                  "name": "sortBy",
                  "value": "CUSTOM",
                  "type": "PortfolioItemsSortByTypes"
                }
              ],
              "concreteType": "PortfolioItemsConnection",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "totalResults",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "numberOfPages",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "pageInfo",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "PageInfo",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "startCursor",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "endCursor",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "edges",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "PortfolioItemsEdge",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "node",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "PortfolioItemV2",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "item",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "Item",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "photos",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "ItemPhoto",
                              "plural": true,
                              "selections": [
                                {
                                  "kind": "LinkedField",
                                  "alias": null,
                                  "name": "versions",
                                  "storageKey": null,
                                  "args": null,
                                  "concreteType": "ItemPhotoVersion",
                                  "plural": true,
                                  "selections": [
                                    {
                                      "kind": "ScalarField",
                                      "alias": null,
                                      "name": "webPath",
                                      "args": null,
                                      "storageKey": null
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'c766a07d18723f39ff783ae85f461ea5';
module.exports = node;
